import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';

interface Entity {
	serviceSlug: string;
	action: string;
	key: string;
}

interface ActionObject {
	text: string;
	action: Function;
}

interface ActionMap {
	[key: string]: ActionObject;
}

interface ServiceMap {
	[serviceSlug: string]: ActionMap;
}

interface entityInput {
	actionKey: string;
	serviceSlug: string;
	paramKey: string;
	items: object[];
	paramsMap: object;
}

const EntityMapByService: ServiceMap = {
	'ply-tracking-events': {
		configuration: {
			text: 'Add a new destination',
			action: (entityInput: entityInput) =>
				AppDialogManagerService.openAnalyticsEventTrackingSettingsDialog({
					currentConnection: {
						actionKey: entityInput.actionKey,
					},
				}),
		},
		event: {
			text: 'New event template',
			action: (entityInput: entityInput) => {
				const { actionKey, serviceSlug, paramKey, items, paramsMap } = entityInput;
				AppDialogManagerService.openAnalyticsCustomEventDialog({
					paramData: {
						actionKey,
						serviceSlug,
						paramKey,
						items,
						configuration: paramsMap.configuration,
					},
				});
			},
		},
	},
};

export function getEntityActions(entity: Entity): ActionObject | undefined {
	const serviceMap = EntityMapByService[entity.serviceSlug];
	if (entity.serviceSlug === 'ply-tracking-events') {
		return serviceMap[entity.key];
	} else {
		return serviceMap[entity.action];
	}
}
